export const blobToSrc = image =>
	image instanceof Blob ? URL.createObjectURL(image) : image
